export default __webpack_public_path__ + "static/media/OSMOS_TORTORA_C2_GRIP_60X120_15.e6402626.jpg";